import { render, staticRenderFns } from "./SectionDeath.vue?vue&type=template&id=251db37b"
import script from "./SectionDeath.vue?vue&type=script&lang=ts"
export * from "./SectionDeath.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports